import Guid from "_shared/guids/guid";
import AHDate from "_shared/dates/date";
import TeamInvitationSchema, {
  TeamInvitationJSON,
  TeamInvitationParams,
} from "marketplace/teams/invitations/_schemas/team-invitation/team-invitation-schema";
import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";

export default class TeamInvitation {
  public static readonly EXAMPLE: TeamInvitation = TeamInvitation.create({
    id: Guid.generate(),
    inviteeId: Guid.generate(),
    teamId: Guid.generate(),
    message: "You are invited to join the team.",
    acceptedAt: undefined,
    closed: false,
  });

  public static create(params: TeamInvitationParams): TeamInvitation {
    const parsed = TeamInvitationSchema.validate(params);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid TeamInvitation parameters.");
    }
    return new TeamInvitation(parsed);
  }

  public static fromJSON(json: TeamInvitationJSON): TeamInvitation {
    const params = TeamInvitationSchema.deserialize(json);
    if (isNullOrUndefined(params)) {
      throw new Error("Invalid TeamInvitation JSON.");
    }
    return new TeamInvitation(params);
  }

  public static fromJSONArray(jsonArray: TeamInvitationJSON[]): TeamInvitation[] {
    return jsonArray.map((json) => TeamInvitation.fromJSON(json));
  }

  public readonly id: Guid;
  public readonly inviteeId: Guid;
  public readonly teamId: Guid;
  public readonly message?: string;
  public readonly acceptedAt?: AHDate;
  public readonly closed: boolean = false;

  public constructor(params: TeamInvitationParams) {
    this.id = params.id;
    this.inviteeId = params.inviteeId;
    this.teamId = params.teamId;
    this.message = params.message;
    this.acceptedAt = params.acceptedAt;
    this.closed = params.closed;
  }

  public toJSON(): TeamInvitationJSON {
    return TeamInvitationSchema.serialize(this);
  }

  public isEqualTo(other: TeamInvitation): boolean {
    return (
      this.id.isEqualTo(other.id) &&
      this.inviteeId.isEqualTo(other.inviteeId) &&
      this.teamId.isEqualTo(other.teamId) &&
      this.message === other.message &&
      ((this.acceptedAt === undefined && other.acceptedAt === undefined) ||
        (this.acceptedAt !== undefined &&
          other.acceptedAt !== undefined &&
          this.acceptedAt.isEqualTo(other.acceptedAt))) &&
      this.closed === other.closed
    );
  }

  public toString(): string {
    return `TeamInvitation { 
      id: ${this.id.toString()}, 
      inviteeId: ${this.inviteeId.toString()}, 
      teamId: ${this.teamId.toString()}, 
      message: ${this.message}, 
      acceptedAt: ${this.acceptedAt?.toJSON() ?? "undefined"}, 
      closed: ${this.closed} 
    }`;
  }
}
